import { InvestmentTransactionType } from "hooks/investments/GetInvestmentTransactionsHook";
import {
  TYPE_LABELS,
  formatDate,
  formatNumber,
  FileCell,
  DotsMenu,
  MobileActions,
} from "./tableUtils";
import { isDesktop } from "utils";

interface PreciousStonesTableProps {
  transactions: InvestmentTransactionType[];
  item: any | null;
  isOwn?: boolean;
  onEditTx?: (tx: InvestmentTransactionType) => void;
}

const PreciousStonesTable = ({
  transactions,
  item,
  isOwn = false,
  onEditTx,
}: PreciousStonesTableProps) => {
  const firstBuyDate = transactions
    .filter((tx) => tx.type === "buy")
    .map((tx) => tx.completedAt ?? tx.createdAt)
    .sort()[0];

  console.log(item, "poka");

  if (!isDesktop()) {
    return (
      <div className="itm-mobile-list">
        {transactions.map((tx) => (
          <div key={tx.uuid} className="itm-mobile-card">
            <table className="side-modal__table">
              <tbody>
                <tr>
                  <td className="side-modal__table-label">Transakcja:</td>
                  <td className="side-modal__table-cell">
                    {TYPE_LABELS[tx.type] ?? tx.type}
                  </td>
                </tr>
                <tr>
                  <td className="side-modal__table-label">Cena zakupu:</td>
                  <td className="side-modal__table-cell">
                    {formatNumber(tx.totalValue)}
                  </td>
                </tr>
                <tr>
                  <td className="side-modal__table-label">Data:</td>
                  <td className="side-modal__table-cell">
                    {formatDate(tx.completedAt ?? tx.createdAt)}
                  </td>
                </tr>
                <tr>
                  <td className="side-modal__table-label">Masa:</td>
                  <td className="side-modal__table-cell">
                    {tx.quantity != null
                      ? `${tx.type === "buy" ? "+" : "-"}${tx.quantity}g`
                      : "Brak"}
                  </td>
                </tr>
                <tr>
                  <td className="side-modal__table-label">Szlif:</td>
                  <td className="side-modal__table-cell">
                    {item?.details?.cut ?? "Brak"}
                  </td>
                </tr>
                <tr>
                  <td className="side-modal__table-label">Barwa:</td>
                  <td className="side-modal__table-cell">
                    {item?.details?.color ?? "Brak"}
                  </td>
                </tr>
                <tr>
                  <td className="side-modal__table-label">Czystość:</td>
                  <td className="side-modal__table-cell">
                    {item?.details?.clarity ?? "Brak"}
                  </td>
                </tr>
                <tr>
                  <td className="side-modal__table-label">Data 1. zakupu:</td>
                  <td className="side-modal__table-cell">
                    {formatDate(firstBuyDate)}
                  </td>
                </tr>
              </tbody>
            </table>
            <MobileActions
              tx={tx}
              onEdit={
                isOwn || tx.type === "sell" ? () => onEditTx?.(tx) : undefined
              }
            />
          </div>
        ))}
      </div>
    );
  }

  return (
    <table className="itm-table">
      <thead>
        <tr>
          <th>Transakcja</th>
          <th>Cena zakupu</th>
          <th>Data</th>
          <th>Masa</th>
          <th>Szlif</th>
          <th>Barwa</th>
          <th>Czystość</th>
          <th>
            Data pierwszego <br /> zakupu Kamieni <br /> szlachetnych
          </th>
          <th>Umowa</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {transactions.map((tx) => (
          <tr key={tx.uuid}>
            <td>{TYPE_LABELS[tx.type] ?? tx.type}</td>
            <td>{formatNumber(tx.totalValue)}</td>
            <td>{formatDate(tx.completedAt ?? tx.createdAt)}</td>
            <td>
              {tx.quantity != null
                ? `${tx.type === "buy" ? "+" : "-"}${tx.quantity}g`
                : "Brak"}
            </td>
            <td>{item?.details?.cut ?? "Brak"}</td>
            <td>{item?.details?.color ?? "Brak"}</td>
            <td>{item?.details?.clarity ?? "Brak"}</td>
            <td>{formatDate(firstBuyDate)}</td>
            <td>
              <FileCell tx={tx} />
            </td>
            <td>
              <DotsMenu
                tx={tx}
                onEdit={
                  isOwn || tx.type === "sell" ? () => onEditTx?.(tx) : undefined
                }
              />
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default PreciousStonesTable;
